import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import DragAndDropImage from "components/MainApp/atoms/Forms/DragAndDropImage";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import permisos from "./permisos";

import styles from "./AppAdd.module.scss";
import i18n from "i18n";

const AppAdd = ({
  app,
  handleChange,
  errors,
  handleChangeImage,
  handleDeleteImage,
  handleSelect,
}) => {
  return (
    <div className={styles["app-add-container"]}>
      <div className={styles["top"]}>
        <div className={styles["left"]}>
          <div className={styles["title"]}>{i18n.t("enter.data")}</div>
          <div className={styles["inputs"]}>
            <MainInput
              label={i18n.t("app.name")}
              required={true}
              id={"app-name"}
              name="name"
              value={app.name}
              handleChange={handleChange}
              error={errors["name"]}
              // disabled
            />
            <MainInput
              label={"Callback URL"}
              required={true}
              id={"app-callback_url"}
              name="callback_url"
              value={app.callback_url}
              handleChange={handleChange}
              error={errors["callback_url"]}
              // disabled
            />
          </div>
        </div>
        <div className={styles["image-input"]}>
          <DragAndDropImage
            name="logo"
            handleChange={handleChangeImage}
            handleDelete={handleDeleteImage}
            file={app.logo}
            error={errors.logo}
          />
        </div>
      </div>
      <div className={styles["bottom"]}>
        <div className={styles["title"]}>{i18n.t("define.permission.levels")}</div>
        <div className={styles["content-view-new-app"]}>
          <table className={styles["permisos"]}>
            <thead>
              <tr>
                <th className={styles["scope-th"]}>{i18n.t("scopes").toUpperCase()}</th>
                <th>{i18n.t("read").toUpperCase()}</th>
                <th>{i18n.t("create").toUpperCase()}</th>
                <th>{i18n.t("update").toUpperCase()}</th>
              </tr>
            </thead>
            <tbody>
              {permisos.map((permiso) => {
                return (
                  <tr key={permiso.id} className={styles["permiso-wrapper"]}>
                    <td className={styles["left"]}>
                      <p className={styles["title"]}>{permiso.name}</p>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() => handleSelect(`${permiso.id}_read`)}
                        checked={app.scopes.includes(`${permiso.id}_read`)}
                      ></Checkbox>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() =>
                          handleSelect(`${permiso.id}_create`)
                        }
                        checked={app.scopes.includes(`${permiso.id}_create`)}
                      ></Checkbox>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() =>
                          handleSelect(`${permiso.id}_update`)
                        }
                        checked={app.scopes.includes(`${permiso.id}_update`)}
                      ></Checkbox>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AppAdd;
